import { render, staticRenderFns } from "./RenderBody.vue?vue&type=template&id=5908f61b&"
import script from "./RenderBody.vue?vue&type=script&lang=js&"
export * from "./RenderBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports